// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color[data-v-df870f0c]{width:3.75rem;min-width:3.75rem;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.circle[data-v-df870f0c]{width:2rem;height:2rem;border-radius:50%}", ""]);
// Exports
module.exports = exports;
